import React, { useEffect, useRef, useState } from 'react';
import './styles/App.scss';
import Header from './components/common-header/Header';
import Hero from './blocks/Hero';
import Nav from './components/Nav';
// import EventPoster from './blocks/EventPoster';
import InteractiveLink from './blocks/InteractiveLink';
import NextGeneration from './blocks/NextGeneration';
import Footer from './components/common-footer/Footer';
import { gsap, ScrollTrigger } from './gsap';
import MobileMenu from './components/MobileMenu';
import Cta from './blocks/Cta';
import TheAccess1 from './blocks/TheAccess1';
import Film from './blocks/Film';
import PhotoBooth from './blocks/PhotoBooth';
import EventRecap from './blocks/EventRecap';

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showArrow, setShowArrow] = useState(true);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const appRef = useRef(); //for detecting scroll direction for nav bar
  const navRef = useRef(); //for fixed position when scrolled up
  const headerRef = useRef(); //for positioning mobile menubar
  const mobileMenuRef = useRef(); //for showing/hiding mobile menu
  const topBarRef = useRef(); //top bar of hamburger icon at nav bar for animation
  const bottomBarRef = useRef(); //bottom bar of hamburger icon at nav bar for animation
  const circleRef = useRef(); // circle icon for close button at mobile menu for animation

  //show/hide mobile menu
  const showMobileMenu = () => {
    menuOpen ? setMenuOpen(false) : setMenuOpen(true);
  };

  useEffect(() => {
    const tl = gsap.timeline();
    menuOpen
      ? tl
          .to(mobileMenuRef.current, { x: 0, duration: 0.2 })
          .to(topBarRef.current, {
            y: 3.5,
            rotation: 135,
            duration: 0.5,
            scale: 0.5
          })
          .to(bottomBarRef.current, { y: -3.5, duration: 0.5, rotation: 45, scale: 0.5 }, '-=0.5')
          .to(circleRef.current, { scale: 1, opacity: 1, duration: 0.5 })
      : tl
          .to(circleRef.current, { scale: 0.5, opacity: 0, duration: 0.2 })
          .to(topBarRef.current, {
            y: 0,
            rotation: 0,
            duration: 0.5,
            scale: 1
          })
          .to(bottomBarRef.current, { y: 0, duration: 0.5, rotation: 0, scale: 1 }, '-=0.5')
          .to(mobileMenuRef.current, { x: '100vw', duration: 0.2 });
  }, [menuOpen]);

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      const width = entries[0].contentRect.width;

      if (width !== screenWidth) {
        setScreenWidth(width);
      }
    });
    resizeObserver.observe(appRef.current);
  }, [screenWidth]);

  // hides nav bar on scroll down & shows on scroll up
  useEffect(() => {
    ScrollTrigger.create({
      trigger: appRef.current,
      start: 'top -20%',
      pinSpacer: false,
      onUpdate: (self) => {
        if (self.direction === 1) {
          gsap.to(navRef.current, { y: '-100%', duration: 1, ease: 'ease-out' });
        } else if (self.direction === -1) {
          gsap.to(navRef.current, { y: 0, duration: 1, ease: 'ease-in' });
        }
      }
    });
  }, []);

  useEffect(() => {
    const header = headerRef.current;
    const nav = navRef.current.style;
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry['isIntersecting'] === false) {
            nav.position = 'fixed';
            nav.top = 0;
          } else {
            nav.position = 'absolute';
            nav.top = '64px';
          }
        });
      },
      { threshold: [0] }
    );
    observer.observe(header);
  }, []);

  return (
    <div
      className="App"
      ref={appRef}
      onTouchStart={() => {
        setShowArrow(false);
      }}
    >
      <Header headerRef={headerRef} clientName={'Morgan Stanley'} />
      <Nav showMobileMenu={showMobileMenu} navRef={navRef} />
      <MobileMenu
        mobileMenuRef={mobileMenuRef}
        circleRef={circleRef}
        topBarRef={topBarRef}
        bottomBarRef={bottomBarRef}
        showMobileMenu={showMobileMenu}
      />
      <Hero screenWidth={screenWidth} />
      {/* <EventPoster width={screenWidth} /> */}
      <TheAccess1 screenWidth={screenWidth} />
      <Film screenWidth={screenWidth} />
      <EventRecap screenWidth={screenWidth} />
      <PhotoBooth />
      <InteractiveLink />
      <NextGeneration showArrow={showArrow} />

      <Cta />
      <Footer />
    </div>
  );
}

export default App;
